import { HoloPanel } from "./HoloPanel";
import { RatingStars } from "./RatingStars";
import { primaryContactAction } from "../lib/contactAction";

export const CallNowPanel = ({ venue, onOutcome, onCall, onVisit, onSkip }) => {
  const action = primaryContactAction(venue);
  return <section className="today-section" data-testid="today-call-now">
    <h2 className="section-label">CHIAMA ADESSO</h2>
    {venue ? <HoloPanel className="call-now-card" testId="call-now-card">
      <strong data-testid="call-now-name">{venue.name}</strong><RatingStars rating={venue.rating} testId="call-now-rating" />
      <p data-testid="call-now-address">{venue.address || "Indirizzo non disponibile"}</p>
      {venue.next_callback_date && <small className="call-now-recall" data-testid="call-now-recall">Richiamo · {venue.next_callback_date}</small>}
      {venue.best_call_time && <small data-testid="call-now-best-time">Orario per chiamare: {venue.best_call_time}</small>}
      <div className="call-now-actions">{action ? <button type="button" className="hud-button hud-secondary"
        onClick={() => onCall(venue, action)} data-testid="call-now-phone-link">{action.label}</button>
        : <p className="contact-missing" data-testid="call-now-phone-missing">telefono non trovato</p>}
        <button type="button" className="hud-button hud-secondary" onClick={() => onVisit(venue)}
          data-testid="call-now-visit-button">Ci sono passato di persona</button>
        <button type="button" className="text-action" onClick={() => onOutcome(venue)} data-testid="call-now-outcome-button">Completa esito</button></div>
      <button type="button" className="text-action" onClick={onSkip} data-testid="call-now-skip-button">Salta → prossimo</button>
    </HoloPanel> : <p className="today-empty" data-testid="call-now-empty">Nessun locale da chiamare.</p>}
  </section>;
};